export const playerId = "player";
export const playerAvatarId = "playerAvatar";
export const playerSocketHandsId = "playerSocketHands";
